import { createSlice, createSelector, PayloadAction } from "@reduxjs/toolkit";
import { Value } from "react-rainbow-components/components/DatePicker";
import { RootState } from "../../store";
import { selectFilteredAwarenessCampaigns } from './list';
import { filterCampaignsByDateRange } from '../../../components/AwarenessCampaigns/utils/dateFilterHelpers';

interface FiltersState {
    searchTerm: string;
    selectedCampaign: string | null; // Store campaign ID instead of the whole object
    dateRange: {
        date: Value | undefined;
    };
}

const initialState: FiltersState = {
    searchTerm: "",
    selectedCampaign: null,
    dateRange: {
        date: undefined
    }
};

const filtersSlice = createSlice({
    name: "awareness_campaigns_filters",
    initialState,
    reducers: {
        setSearchTerm: (state, { payload }: PayloadAction<string>) => {
            state.searchTerm = payload;
        },
        setSelectedCampaign: (state, { payload }: PayloadAction<string | null>) => {
            state.selectedCampaign = payload;
        },
        setDateRange: (state, { payload }: PayloadAction<{ date: Value | undefined }>) => {
            state.dateRange = payload;
        },
        clearDateFilter: (state) => {
            state.dateRange.date = undefined;
        },
        clearAllFilters: (state) => {
            state.searchTerm = "";
            state.selectedCampaign = null;
            state.dateRange.date = undefined;
        }
    }
});

// Actions
export const FiltersActions = filtersSlice.actions;

// Selectors
export const selectSearchTerm = (state: RootState) => state.awareness_campaign.filters.searchTerm;
export const selectSelectedCampaignId = (state: RootState) => state.awareness_campaign.filters.selectedCampaign;
export const selectDateRange = (state: RootState) => state.awareness_campaign.filters.dateRange;

// Combined selector that applies all filters
export const selectFullyFilteredCampaigns = createSelector(
    [selectFilteredAwarenessCampaigns, selectSearchTerm, selectDateRange],
    (campaigns, searchTerm, dateRange) => {
        // Apply search filter
        let filtered = searchTerm 
            ? campaigns.filter(campaign => 
                campaign.name.toLowerCase().includes(searchTerm.toLowerCase())
            )
            : campaigns;
            
        // Apply date range filter
        filtered = filterCampaignsByDateRange(filtered, dateRange);
        
        return filtered;
    }
);

export default filtersSlice.reducer; 